import type { Config } from './@types/config';

const config = (window.reactAppConfig || {}) as Config;

delete window.reactAppConfig;

export { config };
